import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMovePulse12 from './IconMovePulse12';
import IconMovePulse16 from './IconMovePulse16';
import IconMovePulse20 from './IconMovePulse20';
import IconMovePulse24 from './IconMovePulse24';
import IconMovePulse32 from './IconMovePulse32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMovePulse = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMovePulse12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMovePulse16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMovePulse20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMovePulse24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMovePulse32 {...props} />}
        </span>
    );
};
IconMovePulse.displayName = 'FondueIconMovePulse';

export default memo(IconMovePulse);
